import React, { useEffect } from "react";
import Lottie from "lottie-react";
import medicalAnimation from "../Assets/animations/medical.json";

/**
 * Full-Screen Splash Animation
 *
 * Displays a full-screen medical animation when navigating to dashboard after successful login
 * Shows for 1-2 seconds then calls onComplete callback
 */
const SplashScreen = ({ onComplete, duration = 2000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-600 via-blue-500 to-blue-700">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white opacity-10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-white opacity-10 rounded-full blur-3xl animate-pulse delay-700"></div>
      </div>

      {/* Animation Container */}
      <div className="relative z-10">
        <div className="w-64 h-64 md:w-80 md:h-80">
          <Lottie
            animationData={medicalAnimation}
            loop={true}
            autoplay={true}
          />
        </div>

        {/* Loading Text */}
        <div className="text-center mt-8">
          <h2 className="text-white text-2xl md:text-3xl font-bold mb-2">
            Appointment System
          </h2>
          <p className="text-blue-100 text-sm md:text-base mb-4">
            Loading your dashboard...
          </p>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
            <div
              className="w-2 h-2 bg-white rounded-full animate-bounce"
              style={{ animationDelay: "0.1s" }}
            ></div>
            <div
              className="w-2 h-2 bg-white rounded-full animate-bounce"
              style={{ animationDelay: "0.2s" }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
